import { getItem, idKey, setItem } from './localStorage'

const GAME_STATE_ID_KEY = 'szozat-gameState'

let adoptStarted = false

export function readStoredUserId(): string | null {
  if (typeof localStorage === 'undefined') return null

  const explicit = localStorage.getItem(GAME_STATE_ID_KEY)
  if (explicit) return explicit

  const stored = getItem(idKey)
  if (!stored) return null

  try {
    return JSON.parse(stored).id || null
  } catch {
    return null
  }
}

export function persistUserId(userId: string): void {
  localStorage.setItem(GAME_STATE_ID_KEY, userId)
  setItem(idKey, JSON.stringify({ id: userId }), undefined, false)
}

export function adoptUserId(userId: string): void {
  if (typeof window === 'undefined' || adoptStarted) return
  if (readStoredUserId() === userId) return

  adoptStarted = true
  persistUserId(userId)
  window.location.reload()
}
